export const stepsList = [
  { title: '上传文件', id: 1 },
  { title: '数据预览', id: 2 },
  { title: '导入数据', id: 3 }
]
